const IMAGES = [{
    gallery: require("../components/galleryImgs/gallery_1.jpg").default,
    caption: "Nlaystation"
  },
  {
    gallery: require("../components/galleryImgs/gallery_2.jpg").default,
    caption: "Nlaystation"
  },
  {
    gallery: require("../components/galleryImgs/gallery_3.jpg").default,
    caption: "Nlaystation"
  },
  {
    gallery: require("../components/galleryImgs/gallery_4.jpeg").default,
    caption: "Nintendo"
  },
  {
    gallery: require("../components/galleryImgs/gallery_5.jpeg").default,
    caption: "Nintendo"
  },
  {
    gallery: require("../components/galleryImgs/gallery_6.jpeg").default,
    caption: "Nintendo"
  },
  {
    gallery: require("../components/galleryImgs/gallery_7.jpeg").default,
    caption: "X-box"
  },
  {
    gallery: require("../components/galleryImgs/gallery_8.jpeg").default,
    caption: "X-box"
  },
  {
    gallery: require("../components/galleryImgs/gallery_9.jpeg").default,
    caption: "X-box"
  },
  {
    gallery: require("../components/galleryImgs/gallery_10.jpeg").default,
    caption: "Pc"
  },
  {
    gallery: require("../components/galleryImgs/gallery_11.jpeg").default,
    caption: "Pc"
  },
  {
    gallery: require("../components/galleryImgs/gallery_12.jpeg").default,
    caption: "Pc"

  },

];

function returnImgs() {
  return IMAGES;

}

export default returnImgs;


// const IMAGES = [{
//     id: 1,
//     image: "gallery_1.jpg",
//     caption: "Playstation"
//   },
//   {
//     id: 2,
//     image: "gallery_2.jpg",
//     caption: "Playstation"
//   },
//   {
//     id: 3,
//     image: "gallery_3.jpg",
//     caption: "Playstation"
//   },
//   {
//     id: 4,
//     image: "gallery_4.jpeg",
//     caption: "Nintendo"
//   },
//   {
//     id: 5,
//     image: "gallery_5.jpeg",
//     caption: "Nintendo"
//   },
//   {
//     id: 6,
//     image: "gallery_6.jpeg",
//     caption: "Nintendo"
//   },
//   {
//     id: 7,
//     image: "gallery_7.jpeg",
//     caption: "Xbox"
//   },
//   {
//     id: 8,
//     image: "gallery_8.jpeg",
//     caption: "Xbox"
//   },
//   {
//     id: 9,
//     image: "gallery_9.jpeg",
//     caption: "Xbox"
//   },
//   {
//     id: 10,
//     image: "gallery_10.jpeg",
//     caption: "Pc"
//   },
//   {
//     id: 11,
//     image: "gallery_11.jpeg",
//     caption: "Pc"
//   },
//   {
//     id: 12,
//     image: "gallery_12.jpeg",
//     caption: "Pc"
//   },
// ];